/** Source: https://developer.moneris.com/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization */
export const MonerisResponseCode = Object.freeze({
    Success: "001",
    InvalidProfileId: "940",
    ErrorGeneratingToken: "941",
    InvalidProfileIdOrSourceUrl: "942",
    InvalidCardData: "943",
    InvalidExpiryDate: "944",
    InvalidCvd: "945",
});
